<div class="grid-container" style="font-family: 'RobotoDraft', 'Roboto', sans-serif;height: 90%!important;"
    *ngIf="showDashboard==true">
    <div class="row justify-content-around" style="height: 100%;">

        <div class="row dashboard_chart_div">
            <div class="col-md-2 col-sm-4 col-4 dashboard_child_div">
                <div class="dashboard_child_sub_div">
                    <div class="dashboard_child_sub_sub_div">
                        <div class="switch_container">
                            <h6 class="h6_style global-h6">NEW CUSTOMERS</h6>
                        </div>
                    </div>
                    <div class="dashboard_child_sub_sub_div">
                        <div class="dashboard_div_style">
                            <span class="dashboard_span_style">
                                {{dashboardToDivData?.totalWebCustomers}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-sm-4 col-4 dashboard_child_div">
                <div class="dashboard_child_sub_div">
                    <div class="dashboard_child_sub_sub_div">
                        <div class="switch_container">
                            <h6 class="h6_style global-h6">ONLINE ORDERS</h6>
                        </div>
                    </div>
                    <div class="dashboard_child_sub_sub_div">
                        <div class="dashboard_div_style">
                            <span class="dashboard_span_style">
                                {{dashboardToDivData?.webOrders}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-sm-4 col-4 dashboard_child_div">
                <div class="dashboard_child_sub_div">
                    <div class="dashboard_child_sub_sub_div">
                        <div class="switch_container">
                            <h6 class="h6_style global-h6">COUPON REDEEMED</h6>
                        </div>
                    </div>
                    <div class="dashboard_child_sub_sub_div">
                        <div class="dashboard_div_style">
                            <span class="dashboard_span_style">
                                {{dashboardToDivData?.couponRedeemed}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-sm-4 col-4 dashboard_child_div">
                <div class="dashboard_child_sub_div">
                    <div class="dashboard_child_sub_sub_div">
                        <div class="switch_container">
                            <h6 class="h6_style global-h6">DIGIBOARD</h6>
                        </div>
                    </div>
                    <div class="dashboard_child_sub_sub_div_digiboard">
                        <div class="dashboard_child_sub_sub_div_digiboard_sub_div"
                            *ngIf="dashboardToDivData?.digiboardStatus?.length > 1">

                            <div *ngFor="let device of dashboardToDivData?.digiboardStatus" [ngClass]="{
                                    'active': device.isActive === '1',
                                    'inactive': device.isActive === '0',
                                    'dashboard_small-content2': dashboardToDivData?.digiboardStatus?.length === 2,
                                    'dashboard_small-content3': dashboardToDivData?.digiboardStatus?.length === 3
                                  }">
                                <div class="device_name_div">
                                    <span style="white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;">{{device?.screenName}}</span>
                                </div>
                                <div class="device_name_div" *ngIf="device?.isActive === '1'">
                                    ON
                                </div>
                                <div class="device_name_div" *ngIf="device?.isActive === '0'">
                                    OFF
                                </div>
                            </div>
                        </div>
                        <div style="font-size: smaller;
                        font-weight: bold;height: 100%; width: 100%;margin: auto;text-align: center;color: white;"
                            *ngIf="dashboardToDivData?.digiboardStatus?.length == 1">
                            <span *ngIf="dashboardToDivData?.digiboardStatus[0]?.isActive == '1' ">ON</span>
                            <span *ngIf="dashboardToDivData?.digiboardStatus[0]?.isActive == '0' ">OFF</span>
                        </div>
                        <div style="font-size: smaller;
                        font-weight: bold;height: 100%; width: 100%;margin: auto;text-align: center;color: white;"
                            *ngIf="dashboardToDivData?.digiboardStatus?.length == 0">
                            <span>NA</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-sm-4 col-4 dashboard_child_div">
                <div class="dashboard_child_sub_div">
                    <div class="dashboard_child_sub_sub_div">
                        <div class="switch_container">
                            <h6 class="h6_style global-h6">ONLINE B2B ORDERS</h6>
                        </div>
                    </div>
                    <div class="dashboard_child_sub_sub_div">
                        <div class="dashboard_div_style">
                            <span class="dashboard_span_style">
                                {{dashboardToDivData?.totalB2bOrderPlaced}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-2 col-sm-4 col-4 dashboard_child_div">
                <div class="dashboard_child_sub_div">
                    <div class="dashboard_child_sub_sub_div">
                        <div class="switch_container">
                            <h6 class="h6_style global-h6">STORE FEEDBACK</h6>
                        </div>
                    </div>
                    <div class="dashboard_child_sub_sub_div">
                        <div class="dashboard_div_style">
                            <span class="dashboard_span_style">
                                {{dashboardToDivData?.totalFeedbackUnResolved}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row flex-nowrap overflow-auto dashboard_second_div"
            style="display: flex; padding-left: 0px !important; padding-right: 0px !important;">
            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;" *ngIf="displayCoupons">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="display: flex;justify-content: space-between;align-items: center;padding-top: 9px;
                    padding-bottom: 2px;height: 32px;">
                        <span>COUPOUN TREND</span>
                    </div>

                    <div class="card-body" style="padding: 0px;height: 89.5%;">
                        <div class="padding_class" style="height: 100%; overflow: scroll;">
                            <div class="row" class="sub_container">

                                <div class="card-container" *ngFor="let coupon of couponList">
                                    <div class="header_div_coupon">
                                        <span class="font_weight white_color">{{
                                            coupon.couponName }}</span>
                                        <span class="font_weight white_color font_size9">Valid From: {{coupon.fromDate |
                                            date:
                                            constant.viewDateFormat_DMY}} to
                                            {{coupon.toDate | date: constant.viewDateFormat_DMY}}</span>
                                    </div>
                                    <div class="card-section">
                                        <div class="card-box" style="width: 40%;">
                                            <span class="font_weight font_size9 black_color">TODAY</span>
                                            <div class="sub_sub_container">
                                                <p class="p_class_coupon global-p"><span class="font_weight font_size7"><span
                                                            class="green_color_coupon">REDEEMED</span><span
                                                            class="blue_color">/ALLOWED</span></span>
                                                    <span class="second_value"><span class="green_color_coupon">{{
                                                            coupon.redeemedToday }}</span><span class="blue_color">/{{
                                                            coupon.balanceDetail?.rolQty }}</span></span>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="card-box" style="width: 60%;">
                                            <span class="font_weight font_size9 black_color">TILL NOW({{
                                                getDaysSince(coupon.fromDate) }}
                                                days)</span>
                                            <div class="second_sub_container">
                                                <p class="global-p" style="width: 33.3%; margin: 0;"><span
                                                        class="blue_label">ALLOWED</span>
                                                    <span
                                                        class="second_value blue_color">{{coupon.rolQtyTillDate}}</span>
                                                </p>
                                                <p class="global-p" style="width: 33.3%; margin: 0;"><span
                                                        class="red_label">LAPSED</span>
                                                    <span class="lapsed-value red_color">{{coupon.rolQtyTillDate -
                                                        coupon.redeemedTillDate}}</span>
                                                </p>

                                                <p class="global-p" style="width: 33.3%; margin: 0;"><span
                                                        class="blue_label green_color_coupon">REDEEMED</span>
                                                    <span style="font-size: 18px;"
                                                        class=" value green_color_coupon">{{coupon.redeemedTillDate}}</span>
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;" *ngIf="displaySpinWin">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="display: flex;justify-content: space-between;align-items: center;padding-top: 9px;
                    padding-bottom: 2px;height: 32px;">
                        <span>SPIN WIN TREND</span>
                    </div>

                    <div class="card-body" style="padding: 0px;height: 89.5%;">
                        <div class="padding_class" style="height: 100%; overflow: scroll;">
                            <div class="row" class="sub_container">

                                <div class="card-container" *ngFor="let coupon of spinWinList">
                                    <div class="header_div_coupon">
                                        <span class="font_weight white_color">{{
                                            coupon.offerName }} ({{ coupon.productName }})</span>
                                        <span class="font_weight white_color font_size9">Valid From: {{coupon.fromDate |
                                            date:
                                            constant.viewDateFormat_DMY}} to
                                            {{coupon.toDate | date: constant.viewDateFormat_DMY}}</span>
                                    </div>
                                    <div class="card-section">
                                        <div class="card-box" style="width: 40%;">
                                            <span class="font_weight font_size9 black_color">TODAY</span>
                                            <div class="sub_sub_container">
                                                <p class="p_class_coupon global-p"><span class="font_weight font_size7"><span
                                                            class="green_color_coupon">REDEEMED</span><span
                                                            class="blue_color">/ALLOWED</span></span>
                                                    <span class="second_value"><span class="green_color_coupon">{{
                                                            coupon.redeemedToday }}</span><span class="blue_color">/{{
                                                            coupon.balanceDetail?.rolQty }}</span></span>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="card-box" style="width: 60%;">
                                            <span class="font_weight font_size9 black_color">TILL NOW({{
                                                getDaysSince(coupon.fromDate) }}
                                                days)</span>
                                            <div class="second_sub_container">
                                                <p class="global-p" style="width: 33.3%; margin: 0;"><span
                                                        class="blue_label">ALLOWED</span>
                                                    <span
                                                        class="second_value blue_color">{{coupon.rolQtyTillDate}}</span>
                                                </p>
                                                <p class="global-p" style="width: 33.3%; margin: 0;"><span
                                                        class="red_label">LAPSED</span>
                                                    <span class="lapsed-value red_color">{{coupon.rolQtyTillDate -
                                                        coupon.redeemedTillDate - coupon.redeemedToday}}</span>
                                                </p>

                                                <p class="global-p" style="width: 33.3%; margin: 0;"><span
                                                        class="blue_label green_color_coupon">REDEEMED</span>
                                                    <span style="font-size: 18px;"
                                                        class=" value green_color_coupon">{{coupon.redeemedTillDate}}</span>
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="display: flex;justify-content: space-between;align-items: center;padding-top: 9px;
                    padding-bottom: 2px;height: 32px;">
                        <span>ORDER TREND</span>
                        <span style="font-size: 10px;">Credit Limit
                            :
                            {{availableCredit != null ? availableCredit : 'NA'}}</span>
                    </div>
                    <div class="card-body card_body_dashboard">

                        <div style="overflow: hidden;height: 50%;display: flex;align-items: center;"
                            *ngIf="showOrderGraph==true">
                            <google-chart [type]="orderChartData.type"
                                style="width: 100%; min-width: 100%;height: 100%;" [data]="orderChartData.data"
                                [columns]="orderChartData.columnNames" [options]="orderChartData.options">

                            </google-chart>
                        </div>
                        <div style="overflow-y: auto;font-family: sans-serif;height: 50%;" *ngIf="showOrderGraph==true">
                            <table class="dashboard-table body-data-style" style="border:1;border-color: black;">
                                <tr style="height: 10px;" class="th_db">
                                    <th class="tr_th">Order & MTO</th>
                                    <th class="tr_th">Today</th>
                                    <th class="tr_th">Last</th>
                                    <th class="tr_th">{{orderStatus?.currentMonthName}}</th>
                                    <th class="tr_th">{{orderStatus?.previousMonthName}}</th>
                                </tr>

                                <tr class="dashboard_tr">
                                    <th class="tr_td">Ordered</th>
                                    <th class="tr_td">{{todayOrderValue}}</th>
                                    <th class="tr_td">{{lastOrderedValue}}</th>
                                    <th class="tr_td">{{lastMonthOrderedValue}}</th>
                                    <th class="tr_td">{{lastPreviousMonthOrderedValue}}</th>
                                </tr>
                                <tr class="dashboard_tr">
                                    <th class="tr_td">Received</th>
                                    <th class="tr_td">{{todayReceivedValue}}</th>
                                    <th class="tr_td">{{lastReceivedValue}}</th>
                                    <th class="tr_td">{{lastMonthReceivedValue}}</th>
                                    <th class="tr_td">{{lastPreviousMonthReceivedValue}}</th>
                                </tr>
                                <tr class="dashboard_tr">
                                    <th class="tr_td">Returned</th>
                                    <th class="tr_td">{{todayReturnedValue}}</th>
                                    <th class="tr_td">{{lastReturnedValue}}</th>
                                    <th class="tr_td">{{lastMonthReturnedValue}}</th>
                                    <th class="tr_td">{{lastPreviousMonthReturnedValue}}</th>
                                </tr>
                                <tr class="dashboard_tr">
                                    <th class="tr_td">Billed</th>
                                    <th class="tr_td">{{todayBilledValue}}</th>
                                    <th class="tr_td">{{lastBilledValue}}</th>
                                    <th class="tr_td">{{lastMonthBilledValue}}</th>
                                    <th class="tr_td">{{lastPreviousMonthBilledValue}}</th>
                                </tr>
                                <tr class="dashboard_tr">
                                    <th class="tr_td">Payment</th>
                                    <th class="tr_td">{{todayPaymentValue}}</th>
                                    <th class="tr_td">{{lastPaymentValue}}</th>
                                    <th class="tr_td">{{lastMonthPaymentValue}}</th>
                                    <th class="tr_td">{{lastPreviousMonthPaymentValue}}</th>
                                </tr>
                            </table>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="height: 32px;">MTO ORDERS
                    </div>

                    <div class="card-body card_body_dashboard">
                        <div style="height: 50%;display: flex;align-items: center;" *ngIf="showMTOGraph==true">
                            <google-chart style="width: 100%; min-width: 100%;height: 100%;"
                                [type]="makeToOrderDataToday.type" [data]="makeToOrderDataToday.data"
                                [columns]="makeToOrderDataToday.columnNames" [options]="makeToOrderDataToday.options">
                            </google-chart>
                        </div>
                        <div style="height: 50%;display: flex;align-items: center;" *ngIf="showMTOGraph==true">
                            <google-chart style="width: 100%; min-width: 100%;height: 100%;"
                                [type]="makeToOrderDataMonth.type" [data]="makeToOrderDataMonth.data"
                                [columns]="makeToOrderDataMonth.columnNames" [options]="makeToOrderDataMonth.options">
                            </google-chart>
                        </div>

                    </div>
                    <!-- <div class="card-footer" style="background-color:rgb(194, 185, 246);color: white;height: 30px;">&nbsp;
                </div> -->

                </div>
            </div>

            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="height: 32px;">SALE TREND
                    </div>
                    <div class="card-body card_body_dashboard">
                        <div style="height: 50%;display: flex;align-items: center;" *ngIf="showSaleGraph==true">
                            <google-chart style="width: 100%; min-width: 100%;height:100%"
                                [type]="saleDataMonthAmount.type" [data]="saleDataMonthAmount.data"
                                [columns]="saleDataMonthAmount.columnNames" [options]="saleDataMonthAmount.options">
                            </google-chart>
                        </div>
                        <div style="height: 50%;display: flex;align-items: center;" *ngIf="showSaleGraph==true">
                            <google-chart style="width: 100%; min-width: 100%;height:100%"
                                [type]="saleDataMonthBills.type" [data]="saleDataMonthBills.data"
                                [columns]="saleDataMonthBills.columnNames" [options]="saleDataMonthBills.options">
                            </google-chart>
                        </div>
                    </div>
                    <!-- <div class="card-footer" style="background-color:rgb(194, 185, 246);color: white;height: 30px;">&nbsp;
                </div> -->

                </div>
            </div>
        </div>

        <div class="row flex-nowrap overflow-auto dashboard_third_div"
            style="display: flex; padding-left: 0px !important; padding-right: 0px !important;">
            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="height: 32px;">
                        NOTIFICATIONS</div>
                    <div class="card-body smaller_dashboard">

                        <div *ngFor="let msg of messagesDTO; let i = index" class="notificationsLog"
                            style="margin: 6px;border-radius: 6px;">
                            <!-- [ngStyle]="{'background': i % 2 === 0 ? '#adb9ca' : '#dae3f3' }" -->
                            <div class="row align-items-center">
                                <div class="col-md-3 head-data-style" style="padding-left: 5px!important;">
                                    {{msg.title | uppercase }}</div>
                                <div class="col-auto d-flex align-items-center">
                                    <div class="divider"></div>
                                </div>
                                <div class="col-md-8 body-data-style" style="padding-left: 5px!important;">
                                    {{msg.messageDateTime}}<br> {{msg.message}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="card-footer" style="background-color:rgb(194, 185, 246);color: white;height: 30px;">&nbsp;
                </div> -->
                </div>
            </div>

            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="height: 32px;">
                        REMINDERS
                    </div>
                    <div class="card-body smaller_dashboard">
                        <table class="childTable">
                            <tr *ngIf="ROLStatus==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        ROL
                                        Breached for
                                        <strong>{{ROLStatus}}</strong> Products
                                    </td>
                                </h6>
                            </tr>
                            <tr *ngIf="ROLStatus>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        ROL
                                        Breached for
                                        <strong>{{ROLStatus}}</strong> Products
                                    </td>
                                </h6>
                            </tr>
                            <tr *ngIf="MTOInProcessStatus>0">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        ROL
                                        Breached for
                                        <strong>{{MTOInProcessStatus}}</strong> Products
                                    </td>
                                </h6>
                            </tr>
                            <tr *ngIf="MTOProductionStatus>0">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        ROL
                                        Breached for
                                        <strong>{{MTOProductionStatus}}</strong> Products
                                    </td>
                                </h6>
                            </tr>

                            <tr *ngIf="maintenanceOnToday==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        Performance update
                                        for
                                        <strong>{{maintenanceOnToday}}</strong> asset is due on Today.
                                    </td>
                                </h6>
                            </tr>

                            <tr *ngIf="maintenanceOnToday>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        Performance update
                                        for
                                        <strong>{{maintenanceOnToday}}</strong> assets are due on Today.
                                    </td>
                                </h6>
                            </tr>

                            <tr *ngIf="maintenanceinNext5Days==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{maintenanceinNext5Days}}</strong> asset has maintenace due in
                                        next 5
                                        Days.
                                    </td>
                                </h6>
                            </tr>

                            <tr *ngIf="maintenanceinNext5Days>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{maintenanceinNext5Days}}</strong> assets have maintenace due
                                        in next 5
                                        Days.
                                    </td>
                                </h6>
                            </tr>

                            <tr *ngIf="AssetMaintenanceIssuesStatus>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        Maintenance
                                        Resolution
                                        for <strong>{{
                                            AssetMaintenanceIssuesStatus}}</strong> assets are due Today.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiodlapses==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{InsuranceStatusperiodlapses}}</strong> document is lapsed for
                                        Renewal.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiodlapses>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{ InsuranceStatusperiodlapses}}</strong> documents are lapsed
                                        for
                                        Renewal.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod0==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{ InsuranceStatusperiod0}}</strong> document is due for renewal
                                        Today.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod0>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{InsuranceStatusperiod0}}</strong> documents are due for
                                        renewal Today.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod15==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{InsuranceStatusperiod15}}</strong> document is due for renewal
                                        in next
                                        15
                                        Days.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod15>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{ InsuranceStatusperiod15}}</strong> documents are due for
                                        renewal in
                                        next
                                        15 Days.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod30==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{ InsuranceStatusperiod30}}</strong> document is due for
                                        renewal in
                                        next 30
                                        Days.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod30>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{ InsuranceStatusperiod30}}</strong> documents are due for
                                        renewal in
                                        next
                                        30 Days.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod60==1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{ InsuranceStatusperiod60}}</strong> document is due for
                                        renewal in
                                        next 60
                                        Days.
                                </h6>
                            </tr>

                            <tr *ngIf="InsuranceStatusperiod60>1">
                                <h6 class="global-h6" style="margin: 5px;">
                                    <!-- <td style="text-align: left !important; width: 25% !important;"><span
                                            class="textHeader">REMINDERS:</span></td> -->
                                    <td style="text-align: left !important; width: 75% !important; font-size: 10px;">
                                        <strong>{{ InsuranceStatusperiod60}}</strong> documents are due for
                                        renewal in
                                        next
                                        60 Days.
                                </h6>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-xs-12" style="border: 2px solid transparent;height: 100%;">
                <div class="card" style="height: 100%;">
                    <div class="card-header" style="height: 32px;">
                        MY ACTIVITY
                    </div>
                    <div class="card-body smaller_dashboard">

                        <div *ngFor="let act of activityDTO; let i = index" class="notificationsLog"
                            style="margin: 6px;border-radius: 6px;">
                            <!-- [ngStyle]="{'background': i % 2 === 0 ? '#adb9ca' : '#dae3f3' }"> -->
                            <div class="row align-items-center">
                                <div class="col-md-3 head-data-style" style="padding-left: 5px!important;">
                                    {{act.module | uppercase }}</div>
                                <div class="col-auto d-flex align-items-center">
                                    <div class="divider"></div>
                                </div>
                                <div class="col-md-8 body-data-style" style="padding-left: 5px!important;">
                                    Transaction No {{act.transactionNo}} {{act.operation}}d by user
                                    {{act.byUser}} on
                                    {{act.date | date: constant.viewDateFormat_DMYHMS}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="card-footer" style="background-color:rgb(194, 185, 246);color: white;height: 30px;">&nbsp;
                </div> -->
                </div>
            </div>
        </div>

    </div>
</div>